<template lang="pug">
.flowSteps
  .nodetitle
    span 流程处理人
    i(class="el-icon-close" title="关闭流程处理人" v-if="nodeType === 'preview'" @click="stepsClose")
  .nodeShowList(v-loading="stepsLoading" element-loading-text="流程节点加载中...")
    //- 发起流程使用
    .user-steps(v-if="nodeType === 'preview'")
      .user-step( v-for="(item, index) in nodeList" :key="index" :title="item.nodeName" @click="handleStep(index)")
        .top
          .circle
          span {{item.nodeName}}
        .description
          .user-title
            span 审批人：
            span.multiUserDealStrategy(v-if="item.assigneeList.length>1") {{item.multiUserDealStrategy===1?"或签":"会签"}}
            i.el-icon-circle-plus.addStyleApprove(
              v-if="canAddApprover(item)"
              title="范围内添加审批人" @click="addApprover(item.flowNodeDefinitionId)")
          userItem(
            :userList="approverList(item)"
            :disabled="!canAddApprover(item)" v-if="showApproveList(item)"
            @deleteUser="deleteApprove(item.flowNodeDefinitionId,$event)")
          span.expr(v-else) {{item.conditionExpr}}
          .user-title(v-if="item.ccList.length>0")
            span 抄送人：
            el-button.addPeople(icon="el-icon-plus" v-if="item.ccOptional===1" size="mini" type="primary" circle title="选择人员" @click="addCCUser(item)")
          userList.outline(ref="userList" line="inline" disabled :jobNo="false" :list="changeUserName(item.ccList)" v-if="item.ccList.length>0")
          //- span.noUser(v-else) （无抄送人）
    //- 审批查看流程使用
    .user-steps(v-if="nodeType === 'runTime'")
      el-collapse(v-model="activeNode")
        el-collapse-item(v-for="(item, index) in nodeList"  :key="index" :name="item.flowNodeId")
          template(#title)
            .top
              .circle(:class="{'ischeck': item.nodeStatus ==='2'}")
              span {{item.flowNodeName}}{{nodeStatusName(item.nodeStatus)}}
          .description(:class="{'ischeck': item.nodeStatus ==='2'}")
            .user-title 审批人：
              span.multiUserDealStrategy(v-if="item.assigneeList.length>1") {{item.multiUserDealStrategy===1?"或签":"会签"}}
            //- 审批处理
            approverFlow(ref="approverFlow" :info="item" :step="index")
            .user-title(v-if="item.ccList.length>0") 抄送人：
            userList.outline(ref="userList" line="inline" disabled :jobNo="false" :list="changeUserName(item.ccList)" v-if="item.ccList.length>0")
            //- span.noUser(v-else) （无抄送人）
            .accept(v-if="accepApprove(item.nodeStatus,item.assigneeList)")
              userApprove(ref="userApprove" :key="flowKey" @closeDialog="closeDialog" :getBasicData="getBasicData")
            .accept(v-if="item.allowAddNode === 1 && viewMode === 1")
              addApproveNode(ref="addApproveNode")
      //- .user-step(
        v-for="(item, index) in nodeList"
        :class="{'ischeck': item.nodeStatus ==='2'}"
        :key="index"
        :title="item.nodeName"
        @click="handleStep(index)")
        .top
          .circle
          span {{item.flowNodeName}}{{nodeStatusName(item.nodeStatus)}}
        .description
          .user-title 审批人：
            span.multiUserDealStrategy(v-if="item.assigneeList.length>1") {{item.multiUserDealStrategy===1?"或签":"会签"}}
          //- 审批处理
          approverFlow(ref="approverFlow" :info="item" :step="index")
          .user-title(v-if="item.ccList.length>0") 抄送人：
          userList.outline(ref="userList" line="inline" disabled :jobNo="false" :list="changeUserName(item.ccList)" v-if="item.ccList.length>0")
          //- span.noUser(v-else) （无抄送人）
          .accept(v-if="accepApprove(item.nodeStatus,item.assigneeList)")
            userApprove(ref="userApprove" :key="flowKey" @closeDialog="closeDialog" :getBasicData="getBasicData")
          .accept(v-if="item.allowAddNode === 1 && viewMode === 1")
            addApproveNode(ref="addApproveNode")
    .footer
      .flowInline
        .title 流程完后抄送人
        el-button.addPeople(icon="el-icon-plus"  size="mini" type="text" circle title="选择人员" @click="openPerson" v-if="nodeType === 'preview'") 添加抄送人
      userItem(:userList="flowCcList" :disabled="false" v-if="flowCcList.length>0" @deleteUser="deleteAssUser")
      span.noUser(v-else) （无抄送人）
</template>

<script>
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { setCcUserIdList, setFlowNodeDtoList, approveParams, deleteFlowNodeDtoList, addFlowNodeDtoList } from "../config";
import userList from "@/CommonDP/components/userList/index.vue";
import userListApprove from "./userListApprove.vue";
import userApprove from "./userApprove.vue";
import addApproveNode from "./addApproveNode.vue";
import approverFlow from "./approverFlow.vue";
export default {
  components: { userList, userListApprove, userApprove, addApproveNode, userItem, approverFlow },
  props: {
    // preview:在发起流程之前预查询 runTime:审批流程详情
    nodeType: { type: String, default: "runTime" },
    // 审批1 查看2
    viewMode: { type: Number, default: 1 },
    getBasicData: { type: Function, default: null },
    // 流程信息
    flowMessage: { type: Object, default: () => {} }
  },
  data() {
    return {
      currentIndex: 0,
      flowCcList: [],
      stepsLoading: false,
      formData: {},
      activeNode: 0,
      isItemCCList: false // 是否允许申请人选择抄送人
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj,
      userInfo: (state) => state.user.userInfo
    }),
    codePri() {
      return ['User', 'SystemRole', 'SpecRole', 'PrjRole'];
    },
    // 项目内的流程取url或者store存的项目id
    prjId() {
      return this.$route.query.prjId || approveParams.prjId || this.prjInfo.prjId;
    },
    flowInstanceId() {
      return approveParams.detail.flowInstanceId;
    },
    version() {
      return approveParams.version;
    },
    definitionId() {
      return approveParams.definitionId;
    },
    flowKey() {
      return approveParams.flowKey;
    },
    nodeList() {
      return this.nodeType === "preview" ? approveParams.start.flowNodeDtoList || [] : approveParams.nodeAssigneeList || [];
    }
  },
  methods: {
    stepsOpen(param) {
      this.queryFlowNodeList(param);
    },
    async queryFlowNodeList(param) {
      this.stepsLoading = true;
      this.formData = param;
      let res = "";
      try {
        if (this.nodeType === "preview") {
          const { flowDefinitionId, flowKey, formType } = this.flowMessage;
          const params = {
            flowDefinitionId,
            flowDefinitionVersionId: "",
            flowKey,
            enterpriseId: this.enterpriseId,
            prjId: formType === 1 ? this.prjId : "",
            param
          };
          res = await flowService.queryFlowNodeList(params);
          const list = res.data || [];
          setFlowNodeDtoList(list, "add");
        } else {
          res = await flowService.queryInstanceNodes(this.flowInstanceId);
          const list = res.data || [];
          // nodeStatus:0：拒绝 1：同意 2：审批中 3：发起 4：再发起 5：撤销
          this.currentIndex = list.findIndex((e) => e.nodeStatus === "2");
          if (this.currentIndex > 0) this.activeNode = list[this.currentIndex].flowNodeId;
          else this.activeNode = list.map(e => e.flowNodeId);
          setFlowNodeDtoList(list, "approval");
        }
        this.queryCCUserIdList();
        this.stepsLoading = false;
      } catch (error) {
        this.stepsLoading = false;
      }
    },
    async queryCCUserIdList() {
      const res = await flowService.queryCCUserIdList(this.flowInstanceId);
      this.flowCcList = res.data;
      setCcUserIdList(this.flowCcList);
    },
    // 添加该节点审批人
    async addApprover(flowNodeDefinitionId) {
      const props = {
        filterOneself: false,
        codePri: ['User']
      };
      const users = await openMember(props);
      addFlowNodeDtoList(flowNodeDefinitionId, users);
    },
    deleteApprove(flowNodeDefinitionId, user) {
      console.log("删除", flowNodeDefinitionId, user.userId);
      deleteFlowNodeDtoList(flowNodeDefinitionId, user.userId);
    },
    // 流程完后抄送人
    async openPerson() {
      const props = {
        filterOneself: false,
        codePri: this.codePri,
        usersList: this.flowCcList
      };
      const val = await openMember(props);
      this.flowCcList = val;
      setCcUserIdList(this.flowCcList);
    },
    // 动态增加流程的抄送人
    async addCCUser(item) {
      const props = {
        filterOneself: false,
        codePri: this.codePri,
        usersList: []
      };
      const val = await openMember(props);
      const params = {
        flowInstanceId: item.flowNodeDefinitionId,
        userIds: val.map((e) => e.userId)
      };
      await flowService.addCCUserIdList(params);
      this.$message.success("设置成功");
      this.$emit("updateNodesEditor");
    },
    deleteAssUser(user) {
      this.flowCcList = this.flowCcList.filter((e) => e.userId !== user.userId);
    },
    handleStep(index) {
      this.currentIndex = index;
      // this.nodeDetail = node;
    },
    stepsClose() {
      this.$emit("stepsClose");
    },
    nodeStatusName(status) {
      const statusDesccribe = {
        1: () => " (已同意)",
        2: () => " (审批中)",
        3: () => " (发起)",
        4: () => " (再发起)",
        5: () => " (已撤回)",
        0: () => " (已驳回)"
      };
      return statusDesccribe[status] ? statusDesccribe[status]() : "";
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    // 是否需要审批
    accepApprove(nodeStatus, assigneeList) {
      return nodeStatus === "2" && assigneeList.some((e) => e.result === "2" && e.userId === this.userInfo.userId) && this.viewMode === 1;
    },
    changeUserName(list) {
      return list.map((e) => {
        return {
          ...e,
          selectCode: "User",
          name: e.userName
        };
      });
    },
    // 审批人列表 过滤 type=0 审批人 type=1 被抄送人
    approverList(item) {
      return this.changeUserName(item.userDtoList.filter(e => e.type === 0));
    },
    // 是否显示审批人列表
    showApproveList(item) {
      const list = this.approverList(item);
      return list.length > 0;
    },
    // 能否添加审批人
    canAddApprover(item) {
      return item.canChangeAssignee === 1 || item.assigneeSelectionStrategy === '2';
    }
  }
};
</script>
<style lang="scss" scoped>
.flowSteps {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-left: 10px;
}

.nodetitle {
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebefff;
  margin-bottom: 10px;

  span {
    font-weight: 700;
    font-size: 16px;
    line-height: 40px;
    color: var(--theme-color);
  }

  i {
    cursor: pointer;
  }
}

.nodeShowList {
  width: 100%;
  height: calc(100% - 50px);
  padding-right: 5px;
  overflow-x: hidden;
  overflow-y: auto;
}

.user-steps {
  width: 100%;
  display: flex;
  flex-direction: column;

  .user-step {
    width: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;

  }
}
.description {
  margin-left: 7px;
  border-left: 2px solid #c0c4cc;
  padding-left: 10px;
  display: flex;
  flex-direction: column;

  .user-title {
    font-size: 12px;
    line-height: 20px;
    color: var(--theme-color);
    display: flex;
    flex-direction: row;
    align-items: center;

    .multiUserDealStrategy {
      margin-left: 5px;
      font-size: 12px;
      line-height: 20px;
      color: #606266;
    }
    .addStyleApprove{
      margin-left: 5px;
      font-size: 22px;
      line-height: 20px;
      color: var(--theme-color);
      cursor: pointer;
    }
  }
}
.ischeck{
  border-left: 2px solid var(--theme-color);
}
.top {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .circle {
    width: 16px;
    height: 16px;
    background-color: #c0c4cc;
    border-radius: 8px;
  }
  .ischeck{
    background-color: var(--theme-color) !important;
  }

  span {
    margin-left: 7px;
    font-size: 14px;
    font-weight: 700;
  }
}
/deep/.el-collapse{
  border-top:0
}
/deep/.el-collapse-item__content{
  padding-bottom: 10px;
}
.ischeck {
  /deep/.circle {
    background-color: var(--theme-color) !important;
  }

  /deep/.description {
    border-left: 2px solid var(--theme-color) !important;
  }
}

.outline {
  border: none;
  padding-left: 0 !important;
  // display: flex;
  // align-items: flex-start;
}

.expr {
  font-size: 14px;
  line-height: 35px;
}
.noUser {
  font-size: 12px;
  color: darkgray;
}
.footer {
  margin-top: 10px;
}

.flowInline {
  display: flex;
  flex-direction: row;
  align-items: center;

  .title {
    font-size: 16px;
    line-height: 23px;
    color: var(--theme-color);
  }

  .addPeople {
    margin-left: 5px;
  }
}
</style>
